import { useCallback } from 'react';
import { useBuyContext } from './BuyContext';

export type UseBuySelectionReturn = {
  // null = actively declined, undefined = not yet answered.
  selected: string | null | string[] | undefined;
  select: (value: string | null | string[]) => void;
  isSelected: (optionId: string) => boolean;
  toggle: (optionId: string) => void;
};

export const useBuySelection = (groupId: string): UseBuySelectionReturn => {
  const { selections, setSelection } = useBuyContext();
  const selected = selections[groupId];

  const select = useCallback(
    (value: string | null | string[]) => {
      setSelection(groupId, value);
    },
    [groupId, setSelection],
  );

  const isSelected = useCallback(
    (optionId: string): boolean => {
      if (Array.isArray(selected)) return selected.includes(optionId);
      return selected === optionId;
    },
    [selected],
  );

  const toggle = useCallback(
    (optionId: string) => {
      const current = Array.isArray(selected) ? selected : [];
      const next = current.includes(optionId)
        ? current.filter((id) => id !== optionId)
        : [...current, optionId];
      setSelection(groupId, next);
    },
    [groupId, selected, setSelection],
  );

  return { selected, select, isSelected, toggle };
};
